
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/preview/stories/[...slug]",
      function () {
        return require("private-next-pages/preview/stories/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/preview/stories/[...slug]"])
      });
    }
  